<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle :title="$t('student')"></pageTitle>
        <myTableFilter @submit="handleSubmit" :show="{ user_name: true }" />
        <myTable ref="table" :columns="columns" requestUrl="student/list" :showPage="true"></myTable>
      </div>
    </div>
  </div>
</template>

<script>
import myTableFilter from "@/components/myTableFilter";
import myTable from "@/components/myTable";
import pageTitle from "@/components/pageTitle";

export default {
  name: "cent",
  components: {
    myTableFilter,
    myTable,
    pageTitle
  },
  data () {
    return {
      columns: [
        {
          title: this.$t("Info.code"),
          tooltip: true,
          key: "member_id",
          align: "center"
        },
        {
          title: this.$t("cms_email.addTime"),
          tooltip: true,
          key: "add_time",
          align: "center"
        },
        {
          title: this.$t("user"),
          tooltip: true,
          key: "name",
          align: "center"
        },
        {
          title: this.$t("email"),
          tooltip: true,
          key: "member_email",
          align: "center"
        },
      ],
      search: { page: 1, limit: 10 },
    };
  },
  created () { },
  mounted () {
    this.$base.setMenuOpens();
  },
  methods: {
    cancel () {
      this.modal = false;
    },
    error () {
      this.$Message.error(this.$t("improve_information"));
    },
    handleSubmit (params) {
      this.$refs.table.reSearch(params);
    },
  }
};
</script>

<style lang="less" scoped>
/deep/ .table-box {
  .detail_del {
    padding: 0 10px;
    color: #ed4014;
  }
  .ivu-icon-ios-help-circle:before {
    content: '';
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    padding-left: 0;
  }
  .ivu-poptip-confirm .ivu-poptip-footer > .ivu-btn {
    padding: 2px 8px;
    font-size: 14px;
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    font-size: 14px;
  }
}
/deep/ .modal {
  .item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 80%;
    margin: 20px 0 20px 10%;
  }
  .ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/others/student/student.vue